import { ElevenLabsClient } from "elevenlabs"; //

export const evenlabsApi = async () => {
  const client = new ElevenLabsClient({
    apiKey: "sk_fc212f0bed55b2c26d4b1c060715c883637d8bb020cbe5e9",
  });
  const res = await client.conversationalAi.getSignedUrl({
    agent_id: "v4ZuINuyHIGZBz8dI1AH", // this can be found in the dashboard
  });
  return {res, client}
};

export async function GetSIgnetUrl() {
  try {
    
    // Validar que tenemos las credenciales necesarias
    const AGENT_ID = 'v4ZuINuyHIGZBz8dI1AH';
    const API_KEY = 'sk_fc212f0bed55b2c26d4b1c060715c883637d8bb020cbe5e9';

    if (!AGENT_ID || !API_KEY) {
      throw new Error('Missing required credentials');
    }

    const response = await fetch(
      `https://api.elevenlabs.io/v1/convai/conversation/get_signed_url?agent_id=${AGENT_ID}`,
      {
        method: 'GET',
        headers: {
          'xi-api-key': API_KEY,
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error('Error response:', {
        status: response.status,
        statusText: response.statusText,
        errorData
      });
      throw new Error(`Server responded with ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    
    if (!data.signed_url) {
      throw new Error('Response missing signed_url');
    }

    return data.signed_url;

  } catch (error) {
    console.error('Error in GetSignedUrl:', error);
    throw error; // Re-throw para mejor manejo de errores
  }
}

// export const getElevenLabsVoice = async (voiceId) => {
//     const client = new ElevenLabsClient({
//       apiKey: "sk_2991fa67cd404c465afab3983d849ebe2e9ab4285cae615e",
//     });
//     const res = await client.voices.get(voiceId);
//     return res
//   };
  
